export default __webpack_public_path__ + "static/media/ic-timer-x.25c0606a.svg";